import { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isAdmin, setIsAdmin] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Check for tenant admin token
    const token = localStorage.getItem('tenant_admin_token')
    const userStr = localStorage.getItem('tenant_admin_user')

    if (token && userStr) {
      try {
        const user = JSON.parse(userStr)
        setIsAuthenticated(true)
        // Check if user is admin
        setIsAdmin(user.user_type === 'admin' || user.role_slug === 'admin')
      } catch (e) {
        setIsAuthenticated(false)
        setIsAdmin(false)
      }
    } else {
      setIsAuthenticated(false)
      setIsAdmin(false)
    }
    setLoading(false)
  }, [])

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <i className="fas fa-spinner fa-spin"></i>
          Loading...
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/user-login" replace />
  }

  // If user is not admin, redirect to user dashboard
  if (!isAdmin) {
    return <Navigate to="/user/dashboard" replace />
  }

  return children
}

export default ProtectedRoute